// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__SsvRE","input":"Input_input__1HDO2"};